export interface SigninBody {
  email: string;
  password: string;
}

export interface SigninResponse {
  message: string;
  accessToken: string;
  mfa: number;
}